import WebFont from 'webfontloader'
import cloneDeep from 'lodash/cloneDeep'
import uniqueId from 'lodash/uniqueId'

import denormalizeEntity from 'functions/denormalizeEntity'
import generateID from 'functions/generateID'

// When adding params to partials check
// app/services/digital_templates/setup_base_template.rb
// to see an change are required

const partialBase = {
  id: null,
  style: {},
}

export const itemPartials = {
  agent: {
    ...partialBase,
    item_type: 'agent',
    options: {
      agentIndex: 0,
    },
  },
  button: {
    ...partialBase,
    data: {
      value: null,
    },
    item_type: 'button',
    options: {
      text: 'Button',
      color: 'green',
    },
  },
  buttonTrigger: {
    ...partialBase,
    item_Type: 'buttonTrigger',
    options: {
      action: 'toggleMenu',
      icon: 'menu',
    },
  },
  buyerProfiles: {
    ...partialBase,
    item_type: 'buyerProfiles',
    items: [],
    options: {
      customProfiles: {},
    },
    style: {
      width: '100%',
      height: '200px',
    },
  },
  campaignDocuments: {
    ...partialBase,
    item_type: 'campaignDocuments',
    items: [],
    style: {
      width: '100%',
      height: '200px',
    },
  },
  campaignImages: {
    ...partialBase,
    item_type: 'campaignImages',
    items: [],
    style: {
      width: '100%',
      height: '200px',
    },
  },
  campaignInspections: {
    ...partialBase,
    item_type: 'campaignInspections',
    items: [],
    style: {
      width: '100%',
      height: '200px',
    },
  },
  campaignTimeline: {
    ...partialBase,
    item_type: 'campaignTimeline',
    items: [],
    style: {
      width: '100%',
      height: '200px',
    },
  },
  caseStudies: {
    ...partialBase,
    item_type: 'caseStudies',
    items: [],
    style: {
      width: '100%',
      height: '200px',
    },
  },
  comparables: {
    ...partialBase,
    item_type: 'comparables',
    items: [],
    options: {
      comparableSource: 'agency',
    },
    style: {
      width: '100%',
      height: '200px',
    },
  },
  contacts: {
    ...partialBase,
    item_type: 'contacts',
    items: [],
    style: {
      width: '100%',
      height: '200px',
    },
  },
  container: {
    ...partialBase,
    item_type: 'container',
    items: [],
    style: {
      width: '100%',
      height: '200px',
    },
  },
  counter: {
    ...partialBase,
    item_type: 'counter',
    items: [],
    style: {
      width: '100%',
      height: '200px',
    },
  },
  customSections: {
    ...partialBase,
    item_type: 'customSections',
    items: [],
    style: {
      width: '100%',
      height: '200px',
    },
  },
  dataArrayLoop: {
    ...partialBase,
    item_type: 'dataArrayLoop',
    items: [],
    style: {
      width: '100%',
      height: '200px',
    },
  },
  dynamicInputs: {
    ...partialBase,
    item_type: 'dynamicInputs',
    items: [],
    style: {
      width: '100%',
      height: '200px',
    },
  },
  formResponses: {
    ...partialBase,
    item_type: 'formResponses',
    items: [],
    style: {
      width: '100%',
      height: '200px',
    },
  },
  gallery: {
    ...partialBase,
    item_type: 'gallery',
    items: [],
    style: {
      width: '100%',
      height: '200px',
    },
  },
  hashLink: {
    ...partialBase,
    item_type: 'hashLink',
    items: [],
    style: {
      width: '100%',
      height: '200px',
    },
  },
  iframe: {
    ...partialBase,
    item_type: 'iframe',
    style: {
      width: '100%',
      height: '260px',
    },
  },
  image: {
    ...partialBase,
    data: {
      value: null,
    },
    item_type: 'image',
    style: {
      width: '200px',
      height: '260px',
    },
  },
  input: {
    ...partialBase,
    item_type: 'input',
    options: {
      inputComponent: 'input',
    },
    style: {
      width: '100%',
    },
  },
  keyFeatures: {
    ...partialBase,
    item_type: 'keyFeatures',
    items: [],
    style: {
      width: '100%',
      height: '200px',
    },
  },
  mapboxMap: {
    ...partialBase,
    item_type: 'mapboxMap',
    items: [],
    style: {
      width: '100%',
      height: '200px',
    },
  },
  quotes: {
    ...partialBase,
    item_type: 'quotes',
  },
  reviews: {
    ...partialBase,
    item_type: 'reviews',
    items: [],
    options: {
      agentIndex: 0,
    },
    style: {
      width: '100%',
      height: '200px',
    },
  },
  section: {
    ...partialBase,
    item_type: 'section',
    items: [],
    options: {
      toggleable: true,
    },
  },
  sectionGroup: {
    id: null,
    item_type: 'sectionGroup',
    options: {
      sortable: true,
    },
    sections: [],
  },
  team: {
    ...partialBase,
    item_type: 'team',
    items: [],
    style: {
      width: '100%',
      height: '200px',
    },
  },
  text: {
    ...partialBase,
    data: {
      value: 'Text',
    },
    item_type: 'text',
    options: {},
  },
  video: {
    ...partialBase,
    data: {
      value: null,
    },
    item_type: 'video',
    options: {
      videoProvider: 'youtube',
    },
  },
}

function filterGoogleFonts(fontArray){
  return fontArray.filter(fontString => !fontString.match(/typekit|monotype/))
}

export function getFontFamilies(fonts){
  if (fonts){
    const googleFonts = filterGoogleFonts(fonts)
    const cleaned = googleFonts.map((font) => {
      const split = font.split(':')
      return split[0]
    })

    return [...new Set(cleaned)]
  }

  return []
}

export function loadFonts(digitalTemplate){
  if (digitalTemplate && digitalTemplate.options && digitalTemplate.options.fonts){
    const fontArray = [...digitalTemplate.options.fonts]

    // Google fonts are any fonts that do not match the regex as they are the default
    const googleFonts = filterGoogleFonts(fontArray)
    const typeKitFonts = fontArray.filter(fontString => fontString.match(/typekit/)).map(font => font.split(':')[1])

    const loaderOptions = {}

    if (googleFonts.length){
      loaderOptions.google = {
        families: googleFonts,
      }
    }

    if (typeKitFonts.length){
      loaderOptions.typekit = {
        id: typeKitFonts[0],
      }
    }

    WebFont.load(loaderOptions)
  }
}

export function findEntity(type, id, entities){
  const { digitalTemplatePageItems, digitalTemplatePageSectionGroups, digitalTemplatePageSections } = entities

  if (type === 'digitalTemplatePageSectionGroup'){
    return { ...digitalTemplatePageSectionGroups[id], entityType: type } || {}
  }

  if (type === 'digitalTemplatePageSection') return { ...digitalTemplatePageSections[id], entityType: type } || {}
  if (type === 'digitalTemplatePageItem') return { ...digitalTemplatePageItems[id], entityType: type } || {}

  return {}
}

export function updateEntityItemIds(entity){
  if (entity && entity.items){
    return entity.items.map(item => ({
      ...item,
      id: `${generateID()}${uniqueId()}`,
      items: updateEntityItemIds(item),
    }))
  }

  return []
}

export function updateEntityIds(entity){
  const clone = cloneDeep(entity)
  clone.id = `${generateID()}${uniqueId()}`
  clone.items = updateEntityItemIds(clone)

  return clone
}

export function copyEntity(type, id, entities){
  const copiedEntity = findEntity(type, id, entities)
  const denormalizedEntity = denormalizeEntity(type, copiedEntity, entities)

  const newEntity = updateEntityIds(denormalizedEntity)

  return newEntity
}

function findContainer(items, entities){
  let array = items

  if (items && entities){
    array = items.map(itemId => entities[itemId])
  }

  return array.find(item => item.item_type === 'container')
}

export function removeNullNodes(sectionGroups = []){
  const updated = sectionGroups.reduce((sectionGroupsResult, sectionGroup) => {
    if (sectionGroup){
      const updatedSectionGroup = { ...sectionGroup }
      const { sections } = sectionGroup
      const updatedSections = sections ? [...sections] : []

      updatedSectionGroup.sections = updatedSections.reduce((result, section) => {
        if (section){
          const updatedSection = { ...section }
          const { items } = updatedSection
          const updatedItems = items ? [...items] : []

          updatedSection.items = updatedItems.filter(item => item) || []

          result.push(updatedSection)
        }

        return result
      }, [])

      sectionGroupsResult.push(updatedSectionGroup)
    }

    return sectionGroupsResult
  }, [])

  return updated
}

export function findEditableImageItemIds(entityType, entity){
  if (entityType === 'digitalTemplatePageSection') return entity.items || []
  if (entityType === 'digitalTemplatePageItem'){
    const { item_type, id } = entity

    if (item_type === 'image') return [id]

    return []
  }

  return []
}

export const templateTypes = [
  {
    key: 'agreement',
    title: 'Agreement',
  },
  {
    key: 'form',
    title: 'Form',
  },
  {
    key: 'microsite',
    title: 'Microsite',
  },
  {
    key: 'proposal',
    title: 'Proposal',
  },
]

export default findContainer
